import React from "react";
import "../css/Services.css";

const Services2 = () => {
  return (
    <div className="services2">

      {/* HERO */}
      <section className="services2-hero">
        <h1>OUR SERVICES</h1>
        <p>Precision-crafted programs engineered for human performance.</p>
      </section>


      {/* SERVICE GRID */}
      <section className="services2-grid">

        <div className="service-card">
          <div className="line"></div>
          <h2>STRENGTH TRAINING</h2>
          <p>
            Structured resistance systems that build muscle, enhance stability, 
            and maximize power output through biomechanically efficient movement.
          </p>
        </div>

        <div className="service-card">
          <div className="line"></div>
          <h2>CONDITIONING</h2>
          <p>
            High-intensity conditioning that strengthens your cardiovascular engine, 
            improves endurance, and refines athletic capacity.
          </p>
        </div>

        <div className="service-card">
          <div className="line"></div>
          <h2>MOBILITY & CONTROL</h2>
          <p>
            Controlled mobility drills increasing range of motion, fluidity, 
            and long-term joint health — essential for performance longevity.
          </p>
        </div>

        <div className="service-card">
          <div className="line"></div>
          <h2>PERSONAL COACHING</h2>
          <p>
            Elite one-to-one guidance designed around your mechanics, goals, 
            habits, and long-term progression models.
          </p>
        </div>

        <div className="service-card">
          <div className="line"></div>
          <h2>SPORTS PERFORMANCE</h2>
          <p>
            Athlete-driven protocols focusing on explosiveness, agility, 
            sprint mechanics, movement economy, and power conditioning.
          </p>
        </div>

        <div className="service-card">
          <div className="line"></div>
          <h2>RECOVERY SYSTEMS</h2>
          <p>
            Science-based recovery incorporating soft-tissue release, 
            stretching, breathwork, and inflammation management.
          </p>
        </div>

      </section>


      {/* MINIMAL FOOTER-FRIENDLY CLOSE SECTION */}
      <section className="services2-end-block">
        <h1>BUILT WITH INTENTION.</h1>
        <p>
          FLEXOR services exist to refine discipline, elevate performance, 
          and strengthen the connection between body and mind.
        </p>
      </section>

    </div>
  );
};

export default Services2;
